import script from "./ReportHighlightsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportHighlightsCard.vue?vue&type=script&setup=true&lang=js"

import "./ReportHighlightsCard.vue?vue&type=style&index=0&id=03824eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03824eda"]])

export default __exports__